import axios from 'axios'
import { address } from '../../config'
import { toast } from 'react-toastify';
import translations from '../../translations'

const t = translations

const config = () => {
    return {
        headers: { 
            "Authorization": `Bearer ${localStorage.getItem('ahpAccessToken')}`,
            'Content-Type': 'application/json' 
        }
    }
};

// Pobierz listę wszystkich użytkowników
export const getUsers = async () => {
    try {
        const response = await axios.get(`${address}/auth/users`, config())
        return response.data.users || []
    } catch (err) {
        console.log('Error fetching users:', err)
        toast.error('Błąd pobierania listy użytkowników', {
            position: "top-right",
            autoClose: 5000,
        })
        return []
    }
}

// Utwórz nowego użytkownika
export const createUser = async (userData) => {
    try {
        const response = await axios.post(`${address}/auth/register`, {
            name: userData.name,
            email: userData.email,
            password: userData.password,
            role: userData.role || 'USER'
        }, config())
        
        toast.success(t.admin.userCreated, {
            position: "top-right",
            autoClose: 5000,
        })
        
        return response.data
    } catch (err) {
        console.log('Error creating user:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorCreating
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

// Usuń użytkownika
export const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`${address}/auth/user/${userId}`, config())
        
        toast.success(t.admin.userDeleted, {
            position: "top-right",
            autoClose: 5000,
        })
        
        return response.data
    } catch (err) {
        console.log('Error deleting user:', err)
        toast.error(t.admin.errorDeleting, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

export const updateUserLanguage = async (userId, language) => {
    try {
        const response = await axios.put(`${address}/auth/user/${userId}/language`, { language }, config())
        toast.success(t.admin.userLanguageUpdated, {
            position: "top-right",
            autoClose: 5000,
        })
        return response.data
    } catch (err) {
        console.log('Error updating user language:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorUpdatingUserLanguage
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

export const updateUserActiveStudy = async (userId, studyId) => {
    try {
        const response = await axios.put(`${address}/auth/user/${userId}/active-study`, { studyId }, config())
        toast.success(t.admin.activeStudyUpdated, {
            position: "top-right",
            autoClose: 5000,
        })
        return response.data
    } catch (err) {
        console.log('Error updating user active study:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorUpdatingActiveStudy
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

// Pobierz badania użytkownika
export const getUserStudies = async (userId) => {
    try {
        const response = await axios.get(`${address}/auth/user/${userId}/studies`, config())
        return {
            studies: response.data.studies || [],
            activeStudyId: response.data.activeStudyId || null
        }
    } catch (err) {
        console.log('Error fetching user studies:', err)
        toast.error(t.admin.errorFetchingStudies, {
            position: "top-right",
            autoClose: 5000,
        })
        return { studies: [], activeStudyId: null }
    }
}

// Pobierz wszystkie badania
export const getAllStudies = async () => {
    try {
        const response = await axios.get(`${address}/study/studies`, config())
        return response.data || []
    } catch (err) {
        console.log('Error fetching studies:', err)
        toast.error(t.admin.errorFetchingStudies, {
            position: "top-right",
            autoClose: 5000,
        })
        return []
    }
}

export const getSubmissions = async (filters = {}) => {
    try {
        const response = await axios.get(`${address}/study/submissions`, {
            ...config(),
            params: filters
        })
        return response.data?.submissions || []
    } catch (err) {
        console.log('Error fetching submissions:', err)
        toast.error(t.admin.errorFetchingResponses, {
            position: "top-right",
            autoClose: 5000,
        })
        return []
    }
}

export const getSubmissionById = async (submissionId) => {
    try {
        const response = await axios.get(`${address}/study/submissions/${submissionId}`, config())
        return response.data?.submission || null
    } catch (err) {
        console.log('Error fetching submission:', err)
        toast.error(t.admin.errorFetchingResponses, {
            position: "top-right",
            autoClose: 5000,
        })
        return null
    }
}

// Utwórz nowe badanie
export const createStudy = async (studyData) => {
    try {
        const response = await axios.post(`${address}/study/study`, studyData, config())
        
        toast.success(t.admin.studyCreated, {
            position: "top-right",
            autoClose: 5000,
        })
        
        return response.data
    } catch (err) {
        console.log('Error creating study:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorCreatingStudy
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

// Zaktualizuj badanie
export const updateStudy = async (studyId, studyData) => {
    try {
        const response = await axios.put(`${address}/study/study/${studyId}`, studyData, config())
        
        toast.success(t.admin.studyUpdated, {
            position: "top-right",
            autoClose: 5000,
        })
        
        return response.data
    } catch (err) {
        console.log('Error updating study:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorUpdatingStudy
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

// Usuń badanie
export const deleteStudy = async (studyId) => {
    try {
        const response = await axios.delete(`${address}/study/study/${studyId}`, config())
        
        toast.success(t.admin.studyDeleted, {
            position: "top-right",
            autoClose: 5000,
        })
        
        return response.data
    } catch (err) {
        console.log('Error deleting study:', err)
        toast.error(t.admin.errorDeletingStudy, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

export const getCustomTranslations = async (scope = 'user') => {
    try {
        const response = await axios.get(`${address}/translations`, {
            ...config(),
            params: { scope }
        })
        return response.data?.translations || {}
    } catch (err) {
        console.log('Error fetching custom translations:', err)
        toast.error(t.admin.errorFetchingTranslations, {
            position: "top-right",
            autoClose: 5000,
        })
        return {}
    }
}

export const uploadCustomTranslations = async (translationsPayload, scope = 'user') => {
    try {
        const response = await axios.put(`${address}/translations/upload`, {
            translations: translationsPayload,
            scope
        }, config())

        toast.success(t.admin.translationsUploaded, {
            position: "top-right",
            autoClose: 5000,
        })

        return response.data
    } catch (err) {
        console.log('Error uploading custom translations:', err)
        const errorMessage = err.response?.data?.message || t.admin.errorUploadingTranslations
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

const saveCustomLanguage = async ({ language, translation, scope = 'user' }) => {
    return axios.post(`${address}/translations/language`, {
        language,
        translation,
        scope
    }, config())
}

const getTranslationUploadErrorMessage = (err, fallbackMessage) => {
    const errorMessage = err.response?.data?.message || fallbackMessage
    const missingKeys = err.response?.data?.missing
    if (!missingKeys?.length) {
        return errorMessage
    }
    return `${errorMessage}: ${missingKeys.slice(0, 5).join(', ')}${missingKeys.length > 5 ? '…' : ''}`
}

export const createCustomLanguage = async ({ language, translation, scope = 'user' }) => {
    try {
        const response = await saveCustomLanguage({ language, translation, scope })

        toast.success(t.admin.customLanguageCreated, {
            position: "top-right",
            autoClose: 5000,
        })

        return response.data
    } catch (err) {
        console.log('Error creating custom language:', err)
        toast.error(getTranslationUploadErrorMessage(err, t.admin.errorCreatingCustomLanguage), {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

export const uploadLanguageVersion = async ({ language, translation, scope = 'user' }) => {
    try {
        const response = await saveCustomLanguage({ language, translation, scope })

        toast.success(t.admin.translationVersionUploaded, {
            position: "top-right",
            autoClose: 5000,
        })

        return response.data
    } catch (err) {
        console.log('Error uploading translation version:', err)
        toast.error(getTranslationUploadErrorMessage(err, t.admin.errorUploadingTranslations), {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}

export const deleteCustomLanguage = async ({ language, scope = 'user' }) => {
    try {
        const response = await axios.delete(`${address}/translations/delete`, {
            ...config(),
            data: { language, scope }
        })

        toast.success(t.admin.customLanguageDeleted, {
            position: "top-right",
            autoClose: 5000,
        })

        return response.data
    } catch (err) {
        console.log('Error deleting custom language:', err)
        toast.error(err.response?.data?.message || t.admin.errorDeletingCustomLanguage, {
            position: "top-right",
            autoClose: 5000,
        })
        throw err
    }
}
